import { dispatchEventBus } from "@catchoftheday/state";
import { MemberExclusiveProductProps } from "./OnePassMembershipModal";

export const TRIGGER_ONEPASS_PLAN_MODAL_EVENT = {
  type: "@global/TRIGGER_ONEPASS_PLAN_MODAL_EVENT",
};

export const triggerOnePassPlanModal = () => {
  dispatchEventBus({
    type: TRIGGER_ONEPASS_PLAN_MODAL_EVENT.type,
  });
};

export const TRIGGER_ONEPASS_EXCLUSIVE_PRODUCT_MODAL_EVENT = {
  type: "@global/TRIGGER_ONEPASS_EXCLUSIVE_PRODUCT_MODAL_EVENT",
};

export const triggerOnePassExclusiveProductModal = (
  payload: MemberExclusiveProductProps
) => {
  dispatchEventBus<typeof payload>({
    type: TRIGGER_ONEPASS_EXCLUSIVE_PRODUCT_MODAL_EVENT.type,
    payload,
  });
};
